/**
 * TD Product Short Description
 * Reveals a "Show more" / "Show less" toggle when the clamped text overflows.
 * Markup: blocks/td-product-short-description.liquid
 */
if (!customElements.get('td-product-short-desc')) {
  class TdProductShortDesc extends HTMLElement {
    static CLASSES = {
      expanded: 'td-product-short-desc--expanded',
    };

    #text = null;
    #toggle = null;
    #resizeObserver = null;

    connectedCallback() {
      this.#teardown();

      this.#text = this.querySelector('[data-td-short-desc-text]');
      this.#toggle = this.querySelector('[data-td-short-desc-toggle]');
      if (!this.#text || !this.#toggle) return;

      this.#toggle.addEventListener('click', this.#handleToggleClick);

      // Re-measures on width changes (responsive) and once on observe for the initial state.
      this.#resizeObserver = new ResizeObserver(this.#syncToggle);
      this.#resizeObserver.observe(this.#text);

      this.dataset.tdInit = 'true';
    }

    disconnectedCallback() {
      this.#teardown();
    }

    #teardown() {
      if (this.dataset.tdInit !== 'true') return;

      this.#toggle?.removeEventListener('click', this.#handleToggleClick);
      this.#resizeObserver?.disconnect();
      this.#resizeObserver = null;
      this.#text = null;
      this.#toggle = null;
      delete this.dataset.tdInit;
    }

    #syncToggle = () => {
      if (this.classList.contains(TdProductShortDesc.CLASSES.expanded)) return;
      this.#toggle.hidden = this.#text.scrollHeight <= this.#text.clientHeight + 1;
    };

    #handleToggleClick = () => {
      const expanded = this.classList.toggle(TdProductShortDesc.CLASSES.expanded);
      this.#toggle.setAttribute('aria-expanded', String(expanded));
      this.#toggle.textContent = expanded ? this.#toggle.dataset.tdLabelLess : this.#toggle.dataset.tdLabelMore;
    };
  }

  customElements.define('td-product-short-desc', TdProductShortDesc);
}
